<template>
  <button class="hamburger" type="button" :class="hamburgerClass" @click="toggleActiveState">
    <span class="u-sr-only">{{ buttonLabel }}</span>
    <span class="hamburger-box">
      <span class="hamburger-inner" 
      :class="[isSticky]"
      :style="{ 'background-color': `${fillColor} !important` }"></span>
      </span>
    <span class="u-sr-only">{{ buttonLabel }}</span>
  </button>
</template>

<script>


export default {
  name: 'NavbarHamburger',
  props: {
    isMenuOpen: Boolean,
    showSearch: Boolean,
    mobileHamburgerColor: String,
    mobileStickyHamburgerColor: String,
    mobileDefaultHamburgerColor: String,
    mobileInnerDefaultHamburgerColor: String,
    mobileInnerStickyHamburgerColor:String,
    mobileAboutHamburgerColor: String,
    themeIcons: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      currentClass:'default'
    }
  },
  
  computed: {
    isSticky(){
      if(this.isActive){
        this.currentClass = this.themeIcons? 'isActive':'isActive';
      }else{
        this.currentClass = this.themeIcons? 'default':'sticky';
      }
        
        return this.currentClass;
    },
    fillColor() {
      const sheet = document.styleSheets[0];
      var color="";
      if (this.isHomepage){ 

        // if true 
           if (this.themeIcons){ //non-sticky default 
            color= this.mobileDefaultHamburgerColor;  
           }else{ //sticky
            color = this.mobileStickyHamburgerColor;
           }
      }else if(this.isAboutPage){
        if (this.themeIcons){ //non-sticky default 
            color= this.mobileAboutHamburgerColor;  
           }else{ //sticky
            color = this.mobileStickyHamburgerColor;
           }
      }else{ //all inner pages
        if (this.themeIcons){ //default
          color = this.mobileInnerDefaultHamburgerColor;
        }else{
          color = this.mobileInnerStickyHamburgerColor;
        }  
      }
      if (this.isActive){
        color = "#000"
      }
      sheet.insertRule(`.hamburger .${this.currentClass}::after { background-color: ${color} !important; }`, 0);
      sheet.insertRule(`.hamburger .${this.currentClass}::before { background-color: ${color} !important; }`, 0);
      
      return color;
    },
    buttonLabel() {
      return this.isActive ? 'Close Menu' : 'Open Menu'
    },
    hamburgerClass() {
      return {
        'is-active': this.isActive === true
      }
    },
    isActive() {
      return this.isMenuOpen || this.showSearch;
    },
    isAboutPage(){
        return document.querySelector('body.page-about-us') ? true : false;
    },
    isHomepage() {
        return document.querySelector('body.template-index,body.template-login,body.template-register') ? true : false;
    }
  },
  methods: {
    addActiveState() {
      this.$emit('open')
    },
    removeActiveState() {
      this.$emit('close')
    },
    toggleActiveState() {
      if (this.isActive) {
        this.removeActiveState()
      } else {
        this.addActiveState()
      }
    }
  }
}
</script>

<style scoped lang="scss">
$hamburger-layer-width: 20px;
$hamburger-layer-height: 2px;
$hamburger-layer-spacing: 10px;
$hamburger-layer-color: $color-white;


.hamburger {
  cursor: pointer;
  display: inline-block;
  padding: 4px;
  width: $hamburger-layer-width + 8px;
  margin-top: -3px;
  margin-left: 10px;
  height: 24px;

  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;

  // Normalize (<button>)
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  overflow: visible;
  z-index: 5;
  position: relative;

  &.is-active {

    .hamburger-inner,
    .hamburger-inner::before,
    .hamburger-inner::after {
      background-color: $hamburger-layer-color;
    }
  }
}

.hamburger-box {
  width: 100%;
  height: 100%;
  max-height: 15px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: $hamburger-layer-height / -2;

  &,
  &::before,
  &::after {
    height: $hamburger-layer-height;
    background-color: $hamburger-layer-color;
    border-radius: 0;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  &,
  &::after {
    width: 100%;
  }

  &::before {
    width: 100%;
  }

  &::before,
  &::after {
    content: '';
    display: block;
  }

  &::before {
    top: -8px;
  }
}


.hamburger {
  .hamburger-inner {
    top: auto;
    bottom: 0;
    transition-duration: 0.13s;
    transition-delay: 0.13s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);

    &::after {
      top: -16px;
      transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
        opacity 0.1s linear;
    }

    &::before {
      transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
        transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
  }

  .hamburger-inner-black {
    background-color: black;

    &::before,
    &::after {
      background-color: black;
    }
  }

  .hamburger-inner-white {
    background-color: black;

    &::before,
    &::after {
      background-color: black;
    }
  }

  &.is-active {
    .hamburger-inner {
      transform: translate3d(0,
          ($hamburger-layer-spacing + $hamburger-layer-height) * -1,
          0) rotate(-45deg);
      transition-delay: 0.22s;
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);

      &::after {
        top: 0;
        opacity: 0;
        transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
          opacity 0.1s 0.22s linear;
      }

      &::before {
        width: 100%;
        top: 0;
        transform: rotate(-90deg);
        transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
          transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
      }
    }
  }
}
</style>
